import { FormikHelpers } from "formik";
import ProviderForm from "./ProviderForm";
import { useGetProvider } from "./api/getProvider";
import { useEditProvider } from "./api/editProvider";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditProvider = ({handleCloseModal, providerId}: EditProviderProps)  => {
  const getProviderQuery = useGetProvider({providerId: providerId})
  const editProviderMutation = useEditProvider({data: {}, providerId});

  const handleSubmit = async (values: IPostEditProvider, { setSubmitting }: FormikHelpers<IPostEditProvider>): Promise<void> => {
    try {
      await editProviderMutation.mutateAsync({
        data: values,
        providerId: providerId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getProviderQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getProviderQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Παρόχου.</div>
    )
  }

  return (
    <>
      {!getProviderQuery.isLoading && getProviderQuery.data &&
        <ProviderForm initialValues={getProviderQuery.data} type="edit" onSubmit={handleSubmit} />
      }
    </>
  )
}

interface EditProviderProps {
  providerId: number;
  handleCloseModal: () => void;
}

export default EditProvider;